import { z } from 'zod';
// Mensajes de validación genéricos en español, igual en la web y en el API.
z.config(z.locales.es());
export * from './admin.js';
export * from './analytics.js';
export * from './announcements.js';
export * from './api-access.js';
export * from './api-activity.js';
export * from './auth.js';
export * from './branches.js';
export * from './catalog.js';
export * from './common.js';
export * from './company.js';
export * from './customers.js';
export * from './documents.js';
export * from './hacienda.js';
export * from './hacienda-settings.js';
export * from './import-export.js';
export * from './legacy-sync.js';
export * from './mail.js';
export * from './members.js';
export * from './money.js';
export * from './payments.js';
export * from './payroll.js';
export * from './permissions.js';
export * from './preferences.js';
export * from './products.js';
export * from './project-control.js';
export * from './projects.js';
export * from './quotes.js';
export * from './receptions.js';
export * from './sequences.js';
export * from './settlements.js';
//# sourceMappingURL=index.js.map